import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../services/hooks";
import ProductTable from "./ProductTable";
import ProductSchema from "./schema/ProductSchema";
import { useState } from "react";

export default function ProductTables() {
    const { t } = useTranslation('productPage')
    const parts = useAppSelector((state) => state.product.data.parts)
    const accessories = useAppSelector((state) => state.product.data.accessories)
    const kits = useAppSelector((state) => state.product.data.kits)

    const [activePart, setActivePart] = useState<number | null>(null)

    return (<>
        {activePart}
        {parts && parts.length > 0 &&
            <ProductTable data={parts} activePart={activePart} title={t('parts')} colorClass="Second" >
                <ProductSchema setActivePart={setActivePart} data={parts} />
            </ProductTable>
        }
        {accessories && accessories.length > 0 &&
            <ProductTable data={accessories} title={t('accessories')} colorClass="Third" />
        }
        {kits && kits.length > 0 &&
            <ProductTable data={kits} title={t('kits')} colorClass="Second" defaultView={"grid"}/>
        }
    </>)
}